module.exports = __webpack_public_path__ + "f2f007e51615f78c65f22fb62cad3cca.png";